<template>
  <div class="container">
    <div class="school-body">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div class="classheader">
                  <el-page-header @back="goBack" :content="classInfo.name">
                  </el-page-header>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin: 20px">
              <el-col :span="6">
                <div class="classimg_wrapper" :style="{
                    backgroundImage:
                      'url(' + classInfo.curriculum.img_url + ')',
                  }"></div>
              </el-col>
              <el-col :span="18">
                <div class="classdesc_wrapper">
                  <el-row>
                    <el-col :span="24">
                      <div class="classdesc_title" style="font-weight: 500">
                        {{ classInfo.curriculum.title }}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        课程简介:
                      </div>
                    </el-col>
                    <el-col :span="22" v-if="classInfo.curriculum.curriculum_desc == null">
                      <div class="grid-content bg-purple-light" style="font-size: 14px">
                        --
                      </div>
                    </el-col>
                    <el-col :span="22" v-else>
                      <div class="grid-content bg-purple-light" style="font-size: 14px">
                        {{ classInfo.curriculum.curriculum_desc }}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        课程节数:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light">
                        {{ num }}节
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        班级类型:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <span v-if="classInfo.curriculum_class_type === 2">试听班</span>
                      <span v-if="classInfo.curriculum_class_type === 1">正式班</span>
                      <span v-if="classInfo.curriculum_class_type === 3">补课班</span>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div class="classlist">
                  <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <el-tab-pane label="课程目录" name="first">
                      <el-row class="classlist_wrapper" v-for="(item, index) of teacherPlanList" :key="index">
                        <el-col :span="2">
                          <div class="classlist-imgwrapper">
                            <el-image v-if="item.class_covers" class="classimg_wrapper_img" :src="item.class_covers" fit="fill"></el-image>

                            <el-image v-else class="classimg_wrapper_img" :src="item.lessionInfo.img_url" fit="fill">
                            </el-image>
                          </div>
                        </el-col>
                        <el-col :span="16">
                          <div class="classlist-content">
                            <div class="classlist-content-title">
                              <span class="coursetitle">
                                <span>
                                  第{{ index + 1 + (page_no - 1) * 10 }}讲
                                </span>
                                {{ item.lessionInfo.title }}
                              </span>
                              <span>
                                <el-tag v-if="Number(item.sign_state) === 1" effect="dark" size="mini" type="info">已上课
                                </el-tag>
                                <el-tag v-if="Number(item.sign_state) === 2" effect="dark" size="mini" type="primary">未上课
                                </el-tag>
                              </span>
                              <span>
                                <el-tag v-if="item.xm_miss_state === 1" effect="dark" size="mini" type="info">待补课
                                </el-tag>
                              </span>
                            </div>
                            <div class="classlist-content-desc">
                              <el-tooltip class="item" effect="light" :content="item.lessionInfo.desc" placement="top-start">
                                <span>{{ item.lessionInfo.desc }}</span>
                              </el-tooltip>
                            </div>
                            <div class="classlist-content-date">
                              <el-row>
                                <el-col :span="8">
                                  <div class="grid-content bg-purple">
                                    <span>
                                      <span v-if="item.start_class_date === null" class="el-icon-time">暂未排课</span>
                                      <span v-else class="el-icon-time">
                                        {{ item.start_class_date }} -
                                        {{ item.end_class_date.slice(10, 20) }}
                                      </span>
                                    </span>
                                  </div>
                                </el-col>
                                <el-col :span="8">
                                  <div class="grid-content bg-purple-light">
                                    <span v-if="item.stuTotalSignNum !== 0" class="content-desc">
                                      出勤数据:{{ item.stuSignNum }}/{{
                                        item.stuTotalSignNum
                                      }}
                                    </span>
                                    <span v-else class="content-desc">出勤数据: -/-</span>
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div class="classlist-btn">
                            <el-button-group>
                              <el-button size="medium" type="primary" round icon="el-icon-monitor" @click="goTeachlessons(item)">进入课堂</el-button>
                              <el-button size="medium" round plain v-if="$route.query.end_class_state != 1" icon="el-icon-view" type="primary" @click="goNext(item)">备课</el-button>
                            </el-button-group>
                          </div>
                        </el-col>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="学员信息" name="third">
                      <el-row class="classlist_wrapper">
                        <el-table :data="class_stu_list" style="width: 100%" :header-cell-style="{
                            background: '#f5f7fa',
                            color: '#606266',
                            'font-size': '14px',
                          }" stripe size="mini">
                          <el-table-column width="50" align="center" label="序号" fixed="left">
                            <template slot-scope="scope">{{ scope.$index + 1}}</template>
                          </el-table-column>

                          <el-table-column fixed="left" prop="studentUserInfo.realname" label="姓名">
                          </el-table-column>

                          <el-table-column fixed="left" prop="name" label="账号"></el-table-column>

                          <el-table-column prop="studentUserInfo.sex" label="性别"></el-table-column>

                          <!--
                          <el-table-column prop="studentUserInfo.school_name" label="学校"
                            show-overflow-tooltip></el-table-column>
                          <el-table-column prop="studentUserInfo.gradeStr" label="年级"></el-table-column>
                         -->
                          <el-table-column prop="starsNumber" label="星币数"></el-table-column>

                          <!--
                          <el-table-column prop="" label="创作数">
                            <template slot-scope="scope">
                              <el-tooltip class="item" effect="dark" placement="top">
                                <div slot="content">jrcode: {{ scope.row.jr_work_create_num }}<br />
                                  scratch: {{ scope.row.sc_work_create_num }}<br />
                                  python: {{ scope.row.py_work_create_num }}
                                </div>
                                <p>{{ scope.row.createNumber }}</p>
                              </el-tooltip>
                            </template>

                          </el-table-column>
                          <el-table-column prop="" label="获赞数">
                            <template slot-scope="scope">
                              <el-tooltip class="item" effect="dark" placement="top">
                                <div slot="content">jrcode: {{ scope.row.jr_work_zan_num }}<br />
                                  scratch: {{ scope.row.sc_work_zan_num }}<br />
                                  python: {{ scope.row.py_work_zan_num }}
                                </div>
                                <p>{{ scope.row.zanNumber }}</p>
                              </el-tooltip>
                            </template>
                          </el-table-column>

                          -->

                          <el-table-column label="联系电话" show-overflow-tooltip>
                            <template slot-scope="scope">
                              <span>
                                {{ scope.row.studentUserInfo.parent_a }} /
                                {{
                                  scope.row.studentUserInfo.parent_a_phone_num
                                }}
                              </span>
                            </template>
                          </el-table-column>

                          <el-table-column prop="joinClassInfo.in_class_date" label="入班日期" show-overflow-tooltip>
                          </el-table-column>

                          <el-table-column fixed="right" label="操作" width="150" align="center">
                            <template slot-scope="scope">
                              <el-button type="text" size="small" @click="more(scope.row)">平台权限
                              </el-button>

                              <el-button type="text" size="small" @click="updateStuUserPassword(scope.row)">重置密码
                              </el-button>

                              <!-- <el-tooltip v-if="classInfo.subject_id == 1" class="item" effect="dark"
                                content="将该学员在scratch3.fun平台上发布的Jrcode作品同步到steam.fun平台!" placement="top-start">
                                <el-button type="text" size="small" @click="getStuWorksInfo(scope.row)">同步数据</el-button>
                              </el-tooltip> -->
                              <!-- <el-tooltip v-else-if="classInfo.subject_id == 2" class="item" effect="dark"
                                content="将该学员在scratch3.fun平台上发布的Scratch作品同步到steam.fun平台!" placement="top-start">
                                <el-button type="text" size="small" @click="getStuWorksInfo(scope.row)">同步数据</el-button>
                              </el-tooltip> -->
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="关联学员" :visible.sync="dialogVisible3" width="400px">
      <el-form size="mini" :model="stu_form" label-position="top">
        <el-form-item label="原学生账号" required>
          <el-input v-model="stu_form.username"></el-input>
        </el-form-item>

        <el-form-item label="原用户码" required>
          <el-input v-model="stu_form.stuId"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible3 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="getStuScratchWorks">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="确认同步数据" :visible.sync="dialogVisible2" width="60%">
      <div>
        <span style="font-weight: bold">原账号:</span>
        <span style="margin-left: 10px">{{ userInfo.username }}</span>
        <span style="font-weight: bold; margin-left: 20px">真实姓名:</span>
        <span style="margin-left: 10px">{{ userInfo.realname }}</span>

        <span style="font-weight: bold; margin-left: 20px">昵称:</span>
        <span style="margin-left: 10px">{{ userInfo.nickname }}</span>
      </div>

      <div style="margin-top: 20px">
        <el-table :data="workslist" style="width: 100%" size="mini" height="400">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>

          <el-table-column align="center" width="100" label="封面">
            <template slot-scope="scope">
              <el-image v-if="classInfo.subject_id == 2" style="width: 48px; height: 36px" :src="scope.row.covers" fit="fill"></el-image>

              <el-image v-if="classInfo.subject_id == 1" style="width: 48px; height: 36px" :src="scope.row.cover_url" fit="fill"></el-image>
            </template>
          </el-table-column>

          <el-table-column prop="title" label="作品名称"></el-table-column>

          <el-table-column prop="explain" label="操作指南"></el-table-column>
          <el-table-column prop="abstract" label="作品简介"></el-table-column>

          <el-table-column prop="meta.updateAt" label="更新时间"></el-table-column>

          <el-table-column label="发布状态">
            <template slot-scope="scope">
              <span v-if="scope.row.zan !== undefined">已发布</span>
              <span v-else>未发布</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveOldSysWork">开始同步</el-button>
      </span>
    </el-dialog>
    <el-dialog title="平台权限" :visible.sync="dialogVisible4" width="50%" top="5vh" :before-close="handleCloseDialog">
      <div style="padding:10px;">
        <div style="font-weight:bold;">作品社区</div>
        <div>
          <el-switch style="margin-top: 10px;" @change="changeZone_auth" v-model="updateform.zone_auth" active-text="开" inactive-text="关">
          </el-switch>
        </div>
        <div style="margin-top:10px;">
          <span style="color:#707070;font-size: 12px;">开启后，学员可以访问编程社区及共创世界！</span>
        </div>

        <div style="font-weight:bold;margin-top:20px;">赛考中心</div>
        <div>
          <el-switch @change="changeTest_auth" style="margin-top: 10px;" v-model="updateform.test_auth" active-text="开" inactive-text="关">
          </el-switch>
        </div>
        <div style="margin-top:10px;">
          <span style="color:#707070;font-size: 12px;">开启后，学员可以使用赛考中心功能，方便学员进行比赛考级的练习！</span>
        </div>

        <div style="font-weight:bold;margin-top:20px;">信奥专区</div>
        <div>
          <el-switch @change="changeOj_auth" style="margin-top: 10px;" v-model="updateform.oj_auth" active-text="开" inactive-text="关">
          </el-switch>
        </div>
        <div style="margin-top:10px;">
          <span style="color:#707070;font-size: 12px;">开启后，学员可以使用信奥专区进行刷题训练，推荐C++学员开启！</span>
        </div>

        <div style="font-weight:bold;margin-top:20px;">查看题解</div>
        <div>
          <el-switch @change="changeOj_analysis_auth" style="margin-top: 10px;" v-model="updateform.oj_analysis_auth" active-text="开" inactive-text="关">
          </el-switch>
        </div>
        <div style="margin-top:10px;">
          <span style="color:#707070;font-size: 12px;">开启后，学员在信奥专区刷题的时候可以自主查看题目题解，方便学员学习，老师根据实际情况决定是否开启！</span>
        </div>

        <div style="font-weight:bold;margin-top:20px;">学生讲义</div>
        <div>
          <el-switch @change="changeStu_note_auth" style="margin-top: 10px;" v-model="updateform.stu_note_auth" active-text="开" inactive-text="关">
          </el-switch>
        </div>
        <div style="margin-top:10px;">
          <span style="color:#707070;font-size: 12px;">开启后，学员在每次课程结束后，都可以在平台上查看本节课配备的学生讲义，方便学员课程回顾！</span>
        </div>

        <div style="font-weight:bold;margin-top:20px;">Ai助手-P仔</div>
        <div>
          <el-switch @change="changeP_auth" style="margin-top: 10px;" v-model="updateform.p_auth" active-text="开" inactive-text="关">
          </el-switch>
        </div>
        <div style="margin-top:10px;">
          <span style="color:#707070;font-size: 12px;">开启后，学员可以在[我的教室]和[信奥专区]中使用Ai助手-P仔，方便学员自主利用Ai解决问题！</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTchTeachingPlan,
  tchGetStuTchPlanListByTchId,
  tchSaveTchWorkScore,
} from '@/api/classroom/teacher_api'

import {
  updateStuUserPassword,
  saveOldSysScWork,
  saveOldSysJrWork,
  getSchoolOpenMissClassOfTeachingPlan,
  // updateStudentAuth,
} from '@/api/educational'
import {
  api_stuSelectStuClsMsg,
  api_stuUpdateAuth
} from '@/api/javaApi'

import { getStuScratchWorks, getStuJrcodeWorks } from '@/utils/scratch3_api'

import CryptoJS from 'crypto-js'

export default {
  name: 'classlistDescTeacher',
  data() {
    return {
      updateform: {
        id: '',
        p_auth: false,
        zone_auth: false,
        test_auth: false,
        oj_auth: false,
        oj_analysis_auth: false,
        stu_note_auth: false,
        name: '',
        realname: '',
        educational_institution_campus_id: '',
        normal_state: '',
        sex: '',
      },
      dialogVisible4: false,
      //页码管理
      page_no: 1,
      page_size: 500,
      total: 0,

      classid: '',
      currentpage: '1',
      teacherPlanList: [],
      class_stu_list: [],
      classInfo: {},
      subject_code: '',

      //学员密码重置
      form_stu: {
        password: '',
      },

      value: null,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' },
        ],
        date1: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        date2: [
          {
            type: 'date',
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动性质',
            trigger: 'change',
          },
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' },
        ],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',
      activeName: 'first',
      radio1: '上海',
      radio: '3',
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      CourseWork: [], //课程作品
      markform: {
        markpoint: '',
        remark: '',
        is_good: false,
        is_only: false,
      }, //作品点评

      work_title: '', //项目名称
      work_url: '', //项目地址
      workinfo: {}, //预览的项目信息
      StuInfo: {},
      stu_name: '',
      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,

      //JRCODE作品点评
      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      //PYTHON作品点评
      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高
      python_work_url: '',

      current_stu: {
        studentUserInfo: {
          realname: '',
        },
      }, //当前选中的学生
      //同步老学员作品
      sut_id: '5ed81abb73bf0c119431280e', //学员老系统作品
      dialogVisible2: false, //作品同步显示窗口
      dialogVisible3: false,
      userInfo: {}, //学员信息
      workslist: [], //学员作品信息
      num: '',
      stu_form: {
        username: '',
        stuId: '',
        steam_stuId: '',
      },
      colors: ['#f6dd25', '#f6dd25', '#f6dd25'],
    }
  },
  mounted() {
    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
    this.frameHeight = this.frameWidth * 0.75 + 55

    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55

    this.frameWidth2 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight2 = this.frameWidth1 * 0.5 + 55

    this.scale = this.frameWidth / 480

    console.log('获取班级对应的教学计划')
    this.initStuInfo()
  },
  methods: {
    initStuInfo() {
      if (this.$route.query.type1 == '2') {
        this.getSchoolOpenMissClassOfTeachingPlan()
      } else {
        this.getTchTeachingPlan()
      }
    },
    changeP_auth() {
      api_stuUpdateAuth({
        stuId: this.updateform.id,
        pAuth: this.updateform.p_auth,
      }).then(() => {
        console.log('修改学员信息')
        this.$message.success('修改成功')
      })
    },
    changeOj_auth() {
      api_stuUpdateAuth({
        stuId: this.updateform.id,
        ojAuth: this.updateform.oj_auth,
      }).then(() => {
        console.log('修改学员信息')
        this.$message.success('修改成功')
      })
    },
    changeOj_analysis_auth() {
      api_stuUpdateAuth({
        stuId: this.updateform.id,
        ojAnalysisAuth: this.updateform.oj_analysis_auth,
      }).then(() => {
        console.log('修改学员信息')
        this.$message.success('修改成功')
      })
    },
    changeStu_note_auth() {
      api_stuUpdateAuth({
        stuId: this.updateform.id,
        stuNoteAuth: this.updateform.stu_note_auth,
      }).then(() => {
        console.log('修改学员信息')
        this.$message.success('修改成功')
      })
    },
    changeTest_auth() {
      api_stuUpdateAuth({
        stuId: this.updateform.id,
        testAuth: this.updateform.test_auth,
      }).then(() => {
        console.log('修改学员信息')
        this.$message.success('修改成功')
      })
    },
    changeZone_auth() {
      api_stuUpdateAuth({
        stuId: this.updateform.id,
        zoneAuth: this.updateform.zone_auth,
      }).then(() => {
        console.log('修改学员信息')
        this.$message.success('修改成功')
      })
    },
    handleCloseDialog(done) {
      // this.dialogVisible4 = false
      this.getStuSelectStuClsMsg()
      done()
    },
    more(row) {
      console.log(row, 123456789)
      this.updateform.id = row.id
      this.updateform.p_auth = row.p_auth
      this.updateform.oj_auth = row.oj_auth
      this.updateform.oj_analysis_auth = row.oj_analysis_auth
      this.updateform.stu_note_auth = row.stu_note_auth
      this.updateform.zone_auth = row.zone_auth
      this.updateform.test_auth = row.test_auth
      this.updateform.name = row.name
      this.updateform.realname = row.studentUserInfo.realname
      this.updateform.sex = row.studentUserInfo.sex
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.normal_state = row.normal_state
      this.dialogVisible4 = true
    },

    goBack() {
      this.$router.push({
        name: 'myClass',
      })
    },

    goNext(item) {
      console.log(item)
      this.$router.push({
        name: 'prepare',
        query: {
          type1: this.$route.query.type1,
          classid: this.$route.query.class_id,
          end_class_state: this.$route.query.end_class_state,
          curriculumMaterial_id: item.lessionInfo.id,
          backname: 'classlistDescTeacher',
          id: item.curriculum_id,
        },
      })
    },
    //重置学生密码
    updateStuUserPassword(row) {
      this.$confirm(`确定将密码重置为123456吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateStuUserPassword({
          stuId: row.id,
          password: CryptoJS.MD5('123456').toString(
            CryptoJS.enc.Base64
          ),
        }).then((res) => {
          console.log('重置密码')
          console.log(res)
          this.$message.success('重置成功')
        })
      })
    },

    //根据讲次查询学员课堂作品和学员课后作业完成情况
    tchGetStuTchPlanListByTchId(tch_plan_id) {
      console.log('讲次相关作品查询')
      console.log(tch_plan_id)

      tchGetStuTchPlanListByTchId({
        tch_plan_id: tch_plan_id,
      }).then((res) => {
        console.log('查询讲次的课堂作品和作业作品')
        console.log(res)
        this.CourseWork = res.stuTchPlanList
        this.subject_code = res.subjectInfo.code
      })
    },
    getSchoolOpenMissClassOfTeachingPlan() {
      getSchoolOpenMissClassOfTeachingPlan({
        class_id: this.$route.query.class_id,
      }).then((res) => {
        console.log('获取班级对应的教学计划')
        console.log(res)
        this.teacherPlanList = res.teaching_plan_list
        console.log(res.teaching_plan_list.length, 45646)
        this.num = res.teaching_plan_list.length
        this.classInfo = res.classInfo
      })
    },
    getTchTeachingPlan() {
      getTchTeachingPlan({
        class_id: this.$route.query.class_id,
      }).then((res) => {
        console.log('获取班级对应的教学计划')
        console.log(res, 1214564)
        this.teacherPlanList = res.teaching_plan_list
        console.log(res.teaching_plan_list.length, 45646)
        this.num = res.teaching_plan_list.length

        if (res.classInfo.curriculum == undefined) {
          res.classInfo.curriculum = {}
          res.classInfo.curriculum.img_url =
            'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png'
        }
        this.classInfo = res.classInfo
      })
    },

    //作品打分
    MarkWork(id, workinfo, stuinfo, subjectinfo) {
      this.work_title = workinfo.title
      this.work_url = workinfo.work_url
      this.workinfo = workinfo
      this.StuInfo = stuinfo
      this.stu_name = stuinfo.studentUserInfo.realname
      this.tch_work_id = workinfo.id

      this.subject_code = subjectinfo.code

      if (workinfo.is_marking) {
        this.markform = {
          is_good: workinfo.is_good,
          is_only: workinfo.is_only,
          markpoint: workinfo.markpoint,
          remark: workinfo.remark,
        }
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: '',
          remark: '',
        }
      }

      console.log(id)
      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)

      if (this.subject_code == '1') {
        this.dialogFormVisible1 = true
      } else if (this.subject_code == '2') {
        this.dialogFormVisible = true
      } else if (this.subject_code == '3') {
        this.dialogFormVisible2 = true
        console.log('PY课堂作品')
        let routeData = this.$router.resolve({
          name: 'python_course',
          query: {
            type: '2',
            title: workinfo.title,
            plan_id: workinfo.stu_tch_plan_id,
            operate: workinfo.work_type == '1' ? '2' : '4',
          },
        })

        this.python_work_url = routeData.href

        if (workinfo.work_type == '1') {
          this.$store.commit('SET_COURSE_WORK_URL', workinfo.work_url || '')
        } else {
          this.$store.commit('SET_HOME_WORK_URL', workinfo.work_url || '')
        }
      }
    },

    tchSaveTchWorkScore() {
      console.log('教师点评作品')
      console.log(this.markform)
      console.log(this.subject_code)

      tchSaveTchWorkScore({
        subject_code: this.subject_code,
        tch_work_id: this.tch_work_id,
        markpoint: this.markform.markpoint,
        remark: this.markform.remark,
        is_good: this.markform.is_good,
        is_only: this.markform.is_only,
      }).then((res) => {
        console.log('教师点评作品')
        console.log(res)
        if (res.is_update) {
          this.$message.success('点评成功')
          this.dialogFormVisible = false
          this.dialogFormVisible1 = false
          this.dialogFormVisible2 = false
          this.dialogFormVisible3 = false
        }
      })
    },

    onSubmit() {
      console.log('submit!')
    },
    handleClickTab(tab, event) {
      console.log(tab, event)
      if (tab.name === 'third') {
        this.getStuSelectStuClsMsg();
      }
    },
    getStuSelectStuClsMsg() {
      api_stuSelectStuClsMsg({
        classId: this.$route.query.class_id,
        pageRequest: {
          pageNum: this.page_no,
          pageSize: this.page_size,
        }
      }).then(res => {
        console.log(res)
        res.content.forEach(item => {
          item.studentUserInfo = {};
          item.joinClassInfo = {};
          item.name = item.account
          item.starsNumber = item.starNum
          item.oj_analysis_auth = item.ojAnalysisAuth
          item.oj_auth = item.ojAuth
          item.p_auth = item.pauth
          item.id = item.stuId
          item.stu_note_auth = item.stuNoteAuth
          item.test_auth = item.testAuth
          item.zone_auth = item.zoneAuth
          item.oj_testcase_auth = item.ojTestcaseAuth
          item.educational_institution_campus_id = item.eduCampusId
          item.studentUserInfo.realname = item.stuName
          item.studentUserInfo.sex = item.sex
          item.studentUserInfo.parent_a = item.kinship
          item.studentUserInfo.parent_a_phone_num = item.phoneNum
          item.joinClassInfo.in_class_date = item.createdTime
        })
        this.class_stu_list = res.content;
        this.total = res.totalSize;
      })
    },
    handleClick(row) {
      console.log(row)
    },

    handleEdit(row) {
      this.dialogFormVisible = true
      console.log(row)
    },

    goTeachlessons(item) {
      console.log('去上课')
      console.log(item, 4547878)
      sessionStorage.setItem('subject_id', item.subject_id)
      sessionStorage.setItem(
        'teacherPlanList',
        JSON.stringify(this.teacherPlanList)
      )
      sessionStorage.setItem('Classroom', JSON.stringify(item))

      this.$router.push({
        name: 'teachLessons',
        query: {
          type1: this.$route.query.type1,
          curriculumMaterial_id: item.curriculum_meterial_id,
          backname: 'classlistDescTeacher',
          classid: item.curriculum_class_id,
          teaching_plan_id: item.id,
          end_class_date: item.end_class_date,
          // is_create_timetable: this.classInfo.is_create_timetable,
          teachingPlanState: item.teachingPlanState,
          eduCampusId: item.educational_institution_campus_id,
        },
      })
    },

    prepare(item) {
      console.log(item)

      this.$router.push({
        name: 'prepare',
        query: {
          tchPlanId: item.id,
          curriculumMaterial_id: item.curriculum_meterial_id,
          backname: 'classlismyClasstDescTeacher',
          classid: item.curriculum_class_id,
        },
      })
    },

    //同步学员数据
    getStuWorksInfo(row) {
      this.dialogVisible3 = true
      this.stu_form.steam_stuId = row.id
    },

    getStuScratchWorks() {
      if (!this.stu_form.stuId) {
        this.$message.warning('请填写原学生码')
        return
      }

      if (!this.stu_form.username) {
        this.$message.warning('请填写原账号')
        return
      }

      var that = this

      if (this.classInfo.subject_id == 1) {
        console.log('查询学员JR作品')

        getStuJrcodeWorks(this.stu_form.stuId, this.stu_form.username, function (
          res
        ) {
          console.log('学员Jrcode系统作品')
          console.log(res)

          if (res.status == 'success') {
            that.userInfo = res.userInfo
            that.workslist = res.dataArr
            that.dialogVisible2 = true

            for (let k = 0; k < that.workslist.length; k++) {
              console.log(that.workslist[k].zan)
              if (that.workslist[k].zan !== undefined) {
                that.workslist[k].work_type = '2'
              } else {
                that.workslist[k].work_type = '1'
              }
            }
          } else if (res.status == 'fail') {
            that.$notify({
              title: '警告',
              message: res.msg,
              type: 'warning',
            })
          }
        })
      } else if (this.classInfo.subject_id == 2) {
        console.log('查询学员SC作品')

        getStuScratchWorks(
          this.stu_form.stuId,
          this.stu_form.username,
          function (res) {
            console.log('学员scratch3系统作品')
            if (res.status == 'success') {
              that.userInfo = res.userInfo
              that.workslist = res.dataArr

              for (let k = 0; k < that.workslist.length; k++) {
                console.log(that.workslist[k].zan)
                if (that.workslist[k].zan !== undefined) {
                  that.workslist[k].covers =
                    'https://scratch3.fun/released/covers/' +
                    that.workslist[k].covers

                  that.workslist[k].work_url =
                    'https://scratch3.fun/scratch/download/released/' +
                    that.workslist[k].worksid
                  that.workslist[k].work_type = '2'
                } else {
                  that.workslist[k].covers =
                    'https://scratch3.fun/unreleased/covers/' +
                    that.workslist[k].covers
                  that.workslist[k].work_url =
                    'https://scratch3.fun/scratch/downloads?fileid=' +
                    that.workslist[k].localsname
                  that.workslist[k].work_type = '1'
                }
              }

              console.log('组合后的作品列表')
              console.log(that.workslist)

              that.dialogVisible2 = true
            } else if (res.status == 'fail') {
              that.$notify({
                title: '警告',
                message: res.msg,
                type: 'warning',
              })
            }
          }
        )
      }
    },
    //同步SC作品
    saveOldSysWork() {
      var workArr = []
      var work = {}

      if (this.classInfo.subject_id == 1) {
        console.log('同步JR作品')
        if (this.workslist.length == 0) {
          this.$message.warning('无可同步的数据')
          return
        } else {
          for (let k = 0; k < this.workslist.length; k++) {
            console.log(this.workslist[k])
            work = {
              work_url: this.workslist[k].work_url,
              covers: this.workslist[k].cover_url,
              title: this.workslist[k].title,
              abstract: this.workslist[k].abstract,
              explain: this.workslist[k].explain,
              is_only: this.workslist[k].is_only,
              work_type: this.workslist[k].work_type,
            }
            workArr.push(work)
          }
        }

        console.log('同步数据提交的参数')
        console.log(workArr)
        console.log(work)

        saveOldSysJrWork({
          stuId: this.stu_form.steam_stuId,
          workArr: JSON.stringify(workArr),
        }).then((res) => {
          console.log('同步JR作品')
          console.log(res)
          if (res.is_create) {
            this.$message.success('数据同步完成')
            this.stu_form.username = ''
            this.stu_form.stuId = ''
            this.stu_form.steam_stuId = ''
            this.dialogVisible3 = false
            this.dialogVisible2 = false
          }
        })
      } else if (this.classInfo.subject_id == 2) {
        console.log('同步SC作品')
        if (this.workslist.length == 0) {
          this.$message.warning('无可同步的数据')
          return
        } else {
          for (let k = 0; k < this.workslist.length; k++) {
            console.log(this.workslist[k])
            work = {
              work_url: this.workslist[k].work_url,
              covers: this.workslist[k].covers,
              title: this.workslist[k].title,
              abstract: this.workslist[k].abstract,
              explain: this.workslist[k].explain,
              is_only: this.workslist[k].isOnly,
              work_type: this.workslist[k].work_type,
            }
            workArr.push(work)
          }
        }

        console.log('同步数据提交的参数')
        console.log(workArr)
        console.log(work)

        saveOldSysScWork({
          stuId: this.stu_form.steam_stuId,
          workArr: JSON.stringify(workArr),
        }).then((res) => {
          console.log('同步SC作品')
          console.log(res)
          if (res.is_create) {
            this.$message.success('数据同步完成')
            this.stu_form.username = ''
            this.stu_form.stuId = ''
            this.stu_form.steam_stuId = ''
            this.dialogVisible3 = false
            this.dialogVisible2 = false
          }
        })
      }
    },
  },
}
</script>

<style>
.el-dialog {
  width: 900px;
}
</style>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;

  .school-body {
    height: calc(100vh - 81px);

    padding: 10px;

    .classwrapper {
      min-height: calc(100vh - 81px);
      border-radius: 5px;
      // overflow-y: scroll;
      background: white;

      .classheader {
        margin-top: 15px;
        margin-left: 15px;
      }

      .classlist {
        padding-left: 20px;

        .classlist_wrapper {
          padding-top: 0px;
          padding-bottom: 20px;

          .classlist-imgwrapper {
            width: 100%;

            .classimg_wrapper_img {
              width: 100%;
              border-radius: 5px;
            }
          }

          .classlist-content {
            .classlist-content-title {
              padding-left: 40px;
              font-weight: 500;
              line-height: 40px;
              font-size: 14px;

              .coursetitle {
                padding-right: 10px;
                font-weight: bold;
                font-size: 14px;
              }
            }

            .classlist-content-desc {
              padding-left: 40px;
              padding-right: 40px;

              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;

              .content-desc {
                padding-right: 20px;
              }
            }

            .classlist-content-date {
              margin-top: 10px;
              padding-left: 40px;
            }
          }

          .classlist-btn {
            margin-top: 10%;
          }
        }

        .classlist_wrapper::-webkit-scrollbar {
          /*隐藏滚轮*/
          display: none;
        }
      }

      .classimg_wrapper {
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 5px 5px;
      }

      .classdesc_wrapper {
        margin-left: 40px;

        .classdesc_title {
          font-size: 20px;
          padding-bottom: 10px;
        }
      }
    }
  }
}
</style>
